import React, {useContext, useEffect, useState} from 'react';
import { getImages } from '../const';
import { VehicleContext } from '../Context/VehicleContext';


const CustomForm = ({activeChatData,handlePhotoUploadModal, handleHistoricalOptionsModal, photoSIDs, setPhotoSIDs, sendMessage}) => {
    const {getMonroneyLabel, validateVIN, decodeVIN, numberFormatter} = useContext(VehicleContext);

    const [values, setValues] = useState({
        vin: '',
        year: '',
        make: '',
        model: '',
        trim: '',
        miles: '',
        price: '',
        delivery: 'Pickup',
        message: ''
    });

    const updateValues = (index,value) => {
        let newValues = {...values};
        newValues[index] = value;
        setValues(newValues);
    }

    const [VINValid,setVINValid] = useState(false);

    const getLabel = async (vin) => {

        console.log(vin);

        if(validateVIN(vin)) {

            const values = {vin:vin};

            const labelData = await getMonroneyLabel(values);

            console.log(labelData);

            if(labelData.jpg) window.open(labelData.jpg, "_blank", "noreferrer");
        } else
            alert("Invalid VIN");

    }

    const doDecode = async (vin) => {
        const vehicle_data = await decodeVIN(vin);

        console.log(vehicle_data);

        var newValues = {...values};

        if(vehicle_data.Year) newValues.year = vehicle_data.Year;
        if(vehicle_data.Make) newValues.make = vehicle_data.Make;
        if(vehicle_data.Model) newValues.model = vehicle_data.Model;
        if(vehicle_data.Trim) newValues.trim = vehicle_data.Trim;

        setValues(newValues);
    }

    const doSendMessage = async () => {
        console.log(photoSIDs);
        console.log(values);

        if(activeChatData && activeChatData.convo_sid) {
            var messageBody = "";
            messageBody += values.year ? (values.year + " " + values.make + " " + values.model + " " + values.trim +"\n") : "";
            messageBody += values.vin ? "VIN: " + values.vin + "\n": "";
            messageBody += values.vin ? "Miles: " + values.miles + "\n": "";
            messageBody += values.vin ? "Price: " + values.price + "\n": "";
            messageBody += values.vin ? "Delivery: " + values.delivery + "\n": "";
            messageBody += values.message;
            
            sendMessage(activeChatData.convo_sid,activeChatData.chat_service_sid,messageBody,photoSIDs);
            setPhotoSIDs([]);
        }
    }

    useEffect(() => {
        if(validateVIN(values.vin)) {
            doDecode(values.vin);
            
            setVINValid(true);
        } else
            setVINValid(false);
    },[values.vin])

    return (

            <form className="custom-form chatbox-form" autoComplete="off" name="contact-form">
                <div className='row gx-5'>
                    <div className='col-md-6'>
                        <div className='row gx-5'>
                            <div className='col-12'>
                                <div className='form-group'>
                                    <label className='cs-label'>VIN Number</label>
                                    <div className={`d-flex align-items-center vin-flex ${VINValid ? '' : 'full-width'}`}>
                                        <input
                                            type='text'
                                            name='vin'
                                            className='form-control text-uppercase'
                                            placeholder=''
                                            value={values.vin} onChange={(e) => updateValues('vin',e.target.value)}
                                        />
                                        {/* <button type='button' className='red-btn text-center'>
                                            <img src={getImages('white-check-icon.svg')} alt='check-icon' />
                                        </button> */}
                                        {VINValid && (
                                            <button type='button' className='red-btn text-center'>
                                                <img src={getImages('white-check-icon.svg')} alt='check-icon' />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <label className='cs-label'>Year</label>
                                    <input name='year' className='form-control' value={values.year} onChange={(e) => updateValues('year',e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <label className='cs-label'>Make</label>
                                    <input name='make' className='form-control' value={values.make} onChange={(e) => updateValues('make',e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <label className='cs-label'>Model</label>
                                    <input name='model' className='form-control' value={values.model} onChange={(e) => updateValues('model',e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <label className='cs-label'>Trim</label>
                                    <input name='trim' className='form-control' value={values.trim} onChange={(e) => updateValues('trim',e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-md-6'>
                                <div className='form-group'>
                                    <label className='cs-label'>Miles</label>
                                    <input name='miles' className='form-control' value={values.miles} onChange={(e) => updateValues('miles',numberFormatter(e.target.value,false,true))}/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='row gx-5'>
                            <div className='col-md-5'>
                                <div className='form-group mb-38'>
                                    <label className='cs-label'>Price</label>
                                    <input type='text' name='price' className='form-control' value={values.price} onChange={(e) => updateValues('price',numberFormatter(e.target.value,true,true))}/>
                                </div>
                            </div>
                            <div className='col-md-7'>
                                <div className='form-group mb-38'>
                                    <label className='cs-label'>Delivery</label>
                                    <input name='delivery' className='form-control' value={values.delivery} onChange={(e) => updateValues('delivery',e.target.value)}/>
                                </div>
                            </div>
                            <div className='col-12'>
                                <div className='form-group mb-3'>
                                    <input as='textarea' name='message' className='form-control h-196'  value={values.message} onChange={(e) => updateValues('message',e.target.value)}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div className='row mt-3'>
                    <div className='col-md-7'>
                        <button className='md-btn mb-1 red-transparent-btn text-uppercase me-4' type='button' onClick={handleHistoricalOptionsModal}>
                            Historical Options
                        </button>
                        <button className='md-btn mb-1 white-transparent-btn text-uppercase' onClick={() => getLabel(values.vin)}>
                            <img src={getImages('monroney.webp')}/>
                        </button>
                    </div>
                    <div className='col-md-5 text-end'>
                        <button className='text-uppercasen mb-1 me-4 transparent-btn font-12' onClick={(e) => {e.preventDefault(); handlePhotoUploadModal();}}>
                            <span className='plus-icon'></span> Add Photos
                        </button>
                        {/* <label className='custom-upload-button me-4'>
                            <input
                                type='file'
                                name='file'
                                className='isVisuallyHidden'
                                multiple
                                onChange={(event) => {
                                    const files = Array.from(event.currentTarget.files);
                                    setFieldValue('files', files);
                                }}
                            />
                            <img src={getImages('icon-attach.svg')} alt='attach-icon' />
                        </label> */}
                        <button className='md-btn mb-1 red-btn text-uppercase' onClick={(e) => {e.preventDefault(); doSendMessage();}}>
                            Send
                        </button>
                    </div>
                </div>
            </form>
    );
};

export default CustomForm;
